const appConfig = window.env || {
    APIBaseURL: "",
    AddressValidationBaseURL: "",
    ImageBlobBaseUrl: "",
    TimeStamp: "",
    AppInsightsConnectionString: "",
    TestMode: "",
    EpicHandshakeLogEnabled: "",
    ShowErrorDetailsEnabled: ""
  };

export default appConfig;